import { Collapse } from "@mui/material";
import React, { PropsWithChildren } from "react";
import { RateBuilderBottomToolbar } from "@sinch/components/application/RatelistBuilder/RateTreeItem/RateBuilderBottomToolbar";
import { ExpandButton } from "@sinch/components/application/RatelistBuilder/RateTreeItem/RowFooter/ExpandButton";

interface CollapsedToolbarProps extends PropsWithChildren {
  expanded: boolean;
  isWrapped: boolean;
  isPending: boolean;
  onExpand: (event: React.SyntheticEvent) => void;
  childrenCount: number;
  isWrapper: boolean;
}

/**
 * Collapsed toolbar component that shows expand button or bottom toolbar
 * when the tree item is not expanded
 */
export const CollapsedRateBuilderBottomToolbar: React.FC<CollapsedToolbarProps> = ({
  expanded,
  isWrapped,
  isPending,
  onExpand,
  childrenCount,
  isWrapper,
  children,
}) => {
  const hasChildren = childrenCount > 0;

  const shouldShowExpandButton = hasChildren && !isWrapper;

  return (
    <Collapse in={!expanded} mountOnEnter unmountOnExit>
      <RateBuilderBottomToolbar elseToolbar={isWrapper} isWrapped={isWrapped} loading={isPending} shorten>
        {shouldShowExpandButton ? (
          <ExpandButton childrenCount={childrenCount} loading={isPending || expanded} onClick={(e) => onExpand(e)} />
        ) : (
          children
        )}
      </RateBuilderBottomToolbar>
    </Collapse>
  );
};
